import { LicenseColDefs } from './license-col-defs';

/**
 * Column definitions for grid of listings whose licensing process is managed
 * by Rentalscape
 */
export class StrLicenseColDefs extends LicenseColDefs {
  constructor(...args) {
    super(...args);
    this.unitNumberColumn.hide = false;
  }

  propertyDeckardidColumn = this.dateColumn({
    headerName: 'Deckard ID',
    field: 'propertyDeckardid',
    width: 250,
    hide: true,
  });

  licenseApplicationDateColumn = this.dateColumn({
    headerName: 'Application Date',
    field: 'applicationDate',
    width: 135,
  });

  licenseApplicationNumberColumn = this.textColumn({
    headerName: 'Application Number',
    field: 'applicationNumber',
    width: 150,
  });

  licenseIssueDateColumn = this.dateColumn({
    headerName: 'Issue Date',
    field: 'issueDate',
    width: 125,
  });

  licenseExpirationDateColumn = this.dateColumn({
    headerName: 'Expiration Date',
    field: 'expirationDate',
    width: 125,
  });

  renewalSubmittedDateColumn = this.dateColumn({
    headerName: 'Renewal Submitted Date',
    valueGetter: ({ data }) => data?.lastSubmittedRenewal?.applicationDate,
    width: 125,
  });

  licenseHolderColumn = this.textColumn({
    headerName: 'License Holder',
    field: 'licenseHolder',
    width: 200,
  });

  localContactColumn = this.textColumn({
    headerName: 'Local Contact',
    field: 'localContact',
    // this was added so that localContact which is the last column occupies the remaining space
    minWidth: 120,
    flex: 1,
  });

  ownerEmailColumn = this.textColumn({
    headerName: 'Owner Email',
    field: 'ownerEmail',
    width: 200,
  });

  licenseHolderEmailColumn = this.textColumn({
    headerName: 'License Holder Email',
    field: 'licenseHolderEmail',
    width: 200,
  });

  licenseHolderPhoneColumn = this.textColumn({
    headerName: 'License Holder Phone',
    field: 'licenseHolderPhone',
    width: 100,
  });

  licenseHolderAddressColumn = this.textColumn({
    headerName: 'License Holder Address',
    field: 'licenseHolderAddress',
    width: 200,
  });

  propertyDetailsColGroup = {
    headerName: 'Property details',
    children: [
      this.apnColumn,
      this.propertyDeckardidColumn,
      this.addressColumn,
      this.unitNumberColumn,
      this.streetAddressColumn,
      this.cityColumn,
      this.stateColumn,
      this.zipColumn,
      this.ownerColumn,
      this.ownerEmailColumn,
    ],
  };

  strLicenseInfoColGroup = {
    headerName: 'STR license information',
    children: [
      this.licenseColumn,
      this.licenseStatusColumn,
      this.licenseHolderColumn,
      this.licenseHolderEmailColumn,
      this.licenseHolderPhoneColumn,
      this.licenseHolderAddressColumn,
      this.licenseApplicationDateColumn,
      this.licenseApplicationNumberColumn,
      this.licenseIssueDateColumn,
      this.licenseExpirationDateColumn,
      this.renewalSubmittedDateColumn,
      this.localContactColumn,
    ],
  };

  /**
   * Groups of columns for Pending
   *
   * @override
   */
  columnGroups() {
    return [this.propertyDetailsColGroup, this.strLicenseInfoColGroup];
  }
}
